import i18n from '@/i18n'
import { defaultLocale } from '@/config/flavor'

const WIDTHS = {
  none: { zh: '0px', en: '0px' },
  xs: { zh: '70px', en: '96px' },
  sm: { zh: '80px', en: '108px' },
  sm2: { zh: '90px', en: '120px' },
  md: { zh: '100px', en: '140px' },
  md2: { zh: '110px', en: '152px' },
  default: { zh: '120px', en: '160px' },
  md3: { zh: '130px', en: '172px' },
  lg: { zh: '140px', en: '184px' },
  lg2: { zh: '150px', en: '200px' },
  xl: { zh: '160px', en: '212px' },
  xl2: { zh: '180px', en: '236px' },
  xxl: { zh: '200px', en: '260px' },
  xxxl: { zh: '280px', en: '360px' },
  huge: { zh: '300px', en: '380px' }
}

const PX_TO_SIZE = {
  '0px': 'none',
  '70px': 'xs',
  '80px': 'sm',
  '90px': 'sm2',
  '100px': 'md',
  '110px': 'md2',
  '120px': 'default',
  '130px': 'md3',
  '140px': 'lg',
  '150px': 'lg2',
  '160px': 'xl',
  '180px': 'xl2',
  '200px': 'xxl',
  '280px': 'xxxl',
  '300px': 'huge'
}

export function getFormLabelWidth (size = 'default', locale) {
  const lang = locale || i18n.locale || defaultLocale
  const config = WIDTHS[size] || WIDTHS.default
  return config[lang] || config.zh
}

export function getFormLabelSizeByPx (px) {
  return PX_TO_SIZE[px] || 'default'
}

export function syncDocumentLang (locale) {
  const lang = locale || i18n.locale || defaultLocale
  const root = document.documentElement
  root.lang = lang
  root.classList.remove('lang-zh', 'lang-en')
  root.classList.add(`lang-${lang}`)
}
